module.exports = __webpack_public_path__ + "static/image2-030648e6f22054bc86ebc32a6b19d1ef.jpg";